// 参考: https://typescript.nuxtjs.org/ja/cookbook/store.html
import { Plugin } from '@nuxt/types'
import { initializeAxios } from '@app/utils/api'

const accessor: Plugin = ({ $axios }) => {
  initializeAxios($axios)
}

export default accessor
